// extracted by mini-css-extract-plugin
module.exports = {"container":"range-checker_container__3Y7Rx","btn":"range-checker_btn__2-_FA","select":"range-checker_select__1JbS0"};